import SortingOption from './bootstrap-table-sorting-option';

export const stringSortingFunction = (
    data: any[],
    sortingOption: SortingOption
) => {
    const sortedData = data.sort((a, b) => {
        const aValue = a[sortingOption.dataField];
        const bValue = b[sortingOption.dataField];

        const order = sortingOption.order === 'asc' ? 1 : -1;

        if (!(Number.isNaN(+aValue) && Number.isNaN(+bValue))) {
            return order * numberComratation(aValue, bValue);
        }

        return order * stringComparation(aValue, bValue);
    });

    return sortedData;
};

const stringComparation = (a: string, b: string) => a?.localeCompare(b);
const numberComratation = (a: number, b: number) => a - b;
